import PropTypes from "prop-types";
import { useState, useContext, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
// hooks
// import useAuth from "../hooks/useAuth";
// pages
import Login from "../pages/auth/Login";
// components
import LoadingScreen from "../components/LoadingScreen";
import IdentityHelper from "../utilities/IdentityHelper";
import AuthContext from "../context/auth/authContext";
import useAuth from "../hooks/useAuth";
import { OKTA_LOGIN_PAGE } from "../context/auth/types";

// ----------------------------------------------------------------------

ContactCenterAuthGuard.propTypes = {
	children: PropTypes.node,
};

export default function ContactCenterAuthGuard({ children }) {
	const { pathname, state } = useLocation();
	const isContactCenter = pathname?.includes("contactCenter");
	const [requestedLocation, setRequestedLocation] = useState(null);
	const [isAuthenticated, setIsAuthenticated] = useState(false);
	const [isInitialLoading, setIsInitialLoading] = useState(true);
	const authDataset = useAuth();
	const { setAuthenticationDetails, getOktaAccessToken } = { ...authDataset };

	const redirectToOktaLogin = () => {
		window.location.href = OKTA_LOGIN_PAGE;
	};

	//TODO: REMOVE BEFORE RELEASE
	//* TODO: isDev PRE-DEPLOY
	const isDev = false;

	useEffect(() => {
		async function initialize() {
			try {
				//TODO: REMOVE BEFORE RELEASE
				if (isDev === true) {
					setIsAuthenticated(true);
					setIsInitialLoading(false);
					// update the value in the context store so that other age can have access to it.
					setAuthenticationDetails(true);
					return;
				}
				//TODO: REMOVE BEFORE RELEASE

				IdentityHelper.initOktaConfig();
				let oktaClient = IdentityHelper.getOktaAuthClient();
				let sessionExist = await oktaClient.session.exists();
				if (sessionExist) {
					let oktaAccessToken = await getOktaAccessToken();
					if (oktaAccessToken) {
						setIsAuthenticated(true);
						setIsInitialLoading(false);
						// update the value in the context store so that other age can have access to it.
						setAuthenticationDetails(true);
					} else {
						setIsInitialLoading(false);
					}
				} else {
					// "The CC agent session does not exist, redirecting to the okta login page"
					setIsInitialLoading(false);
				}
			} catch (err) {
				console.error("Error occurred while calling Okta library - ", err);
			}
		}

		initialize();
	}, []);

	if (isInitialLoading) {
		return <LoadingScreen />;
	}

	if (!isAuthenticated) {
		if (pathname !== requestedLocation) {
			setRequestedLocation(pathname);
		}
		return redirectToOktaLogin();
	}

	// if (requestedLocation && pathname !== requestedLocation) {
	//   setRequestedLocation(null);
	//   return <Navigate to={requestedLocation} />;
	// }

	return <>{children}</>;
}
